'use strict'

import template from './document-search.template.pug'

export class DocumentSearchController {
  constructor($mdDialog, $filter) {
    'ngInject'
    Object.assign(
      this,
      { $mdDialog, $filter },
      {
        filteredDocuments: null,
      },
    )
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  search(query) {
    if (!query || !query.length) {
      this.filteredDocuments = null
      return
    }
    this.filteredDocuments = this.$filter('searchJsonFilter')(this.documents, query)
  }
}

export const documentSearchComponent = {
  controller: DocumentSearchController,
  controllerAs: '$ctrl',
  clickOutsideToClose: true,
  escapeToClose: true,
  template: template(),
}

export const documentSearchConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('documentSearchDialog', {
    options: () => {
      return documentSearchComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/documents/containers/document-search/document-search.component.js